'use client';

import clsx from 'clsx';
export const TableButton = ({
  variant,
  size = 'md',
  className,
  children,
  disabled,
  ...props
}) => {
  return <button type="button" disabled={disabled} className={clsx('inline-flex items-center gap-1 rounded-full text-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed', size === 'sm' && 'px-2 py-0.5 min-h-6', size === 'md' && 'px-2 py-0.75 min-h-7', variant === 'dotted' && 'border border-gray-400 border-dashed text-gray-600 hover:bg-brand/10 hover:border-brand/40 cursor-pointer', variant === 'outlined' && 'border border-brand text-brand hover:bg-brand/5 cursor-pointer', variant === 'contained' && 'border border-transparent bg-brand text-white hover:bg-brand-700 cursor-pointer', className)} {...props}>
            {children}
        </button>;
};